"use client";

import { NewsletterForm } from "@/components/forms/NewsletterForm";

/**
 * Newsletter signup form rendered in the Footer banner.
 * The `compact` prop removes the title+body block so the Footer
 * can control that layout itself.
 */
export function FooterNewsletter({ compact = false }: { compact?: boolean }) {
  if (compact) {
    return <NewsletterForm />;
  }

  return (
    <div>
      <NewsletterForm />
    </div>
  );
}

export default FooterNewsletter;

